import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LogoutIcon(props: IconProps) {
    return <Icon {...props} iconKey={"logout"}/>
}
